import LuaModule from "../lua";
import etlua from "../lualib/etlua.lua";
import json from "../lualib/json.lua";

export function renderCode(template: string, data: string, setCode: (code: string) => void, data_processor?: string) {
    let hasOutput = false;
    let trunks: string[] = [];
    let oldPrint = LuaModule.print;
    LuaModule.print = (text: string) => {
        if ("emsc" !== text) {
            hasOutput = true;
            trunks.push(text);
        }
    };
    let data_processor_code = data_processor || `
        function(data)
            return data
        end
    `;
    let luaCode = `
        local _G = _G
        local print = _G.print
        local etlua = (function()
            ${etlua}
        end)()
        local json = (function()
            ${json}
        end)()
        local data = json.decode([[${data}]])
        if nil == data then
            print("invalid json data")
        else
            local actualData = (${data_processor_code})(data)
            local content = etlua.compile([[${template}]])(actualData)
            print(content)
        end
    `;
    (LuaModule as any).ccall("run_lua", 'number', ['string'], [luaCode]);
    LuaModule.print = oldPrint;
    if (hasOutput) {
        setCode(trunks.join("\n"));
    }
}

export async function exportTemplate(templates: {
    code: string;
    export_path?: string;
}[]) {
    if (!(window as any).__TAURI__) {
        console.error("Native client required.");
        return;
    }
    return (window as any).__TAURI__
      .invoke("export_template", {
        templates: templates
      });
}